import { OrderCommunication, EntityConnectionAction, EntityCommunicationState } from "../../domain/entities/order-communication.entity";

interface OrderCommunicationDocumentApi {
  id: string;
  name: string | null;
  fileName: string | null;
  size: number | null;
  extension: string | null;
}

interface OrderCommunicationEventApi {
  id: string;
  occurredAt: string;
  isSuccess: boolean;
  response: string | null;
  primaryDocument: OrderCommunicationDocumentApi | null;
}

export interface OrderCommunicationApi {
    id: string;
    contractId: number;
    qualityControlId: string | null;
    qualityControlVersion: number | null;
    action: number;
    state: number;
    createdAt: string;
    finishedAt: string | null;
    isFinished: boolean;
    isSuccess: boolean | null;
    hasErrors: boolean | null;
    errors: string | null;
    requiresReview: boolean | null;
    reviewComments: string | null;
    events: OrderCommunicationEventApi[] | null;
}

export interface OrderCommunicationListApiRespone {
    items: OrderCommunicationApi[];
}

export class OrderCommunicationMapper {
    static toDomain(api: OrderCommunicationApi): OrderCommunication {
        return {
            id: api.id,
            contractId: api.contractId,
            qualityControlId: api.qualityControlId,
            qualityControlVersion: api.qualityControlVersion,
            action: api.action as EntityConnectionAction,
            state: api.state as EntityCommunicationState,
            createdAt: new Date(api.createdAt),
            finishedAt: api.finishedAt ? new Date(api.finishedAt) : null,
            isFinished: api.isFinished,
            isSuccess: api.isSuccess,
            hasErrors: api.hasErrors,
            errors: api.errors,
            requiresReview: api.requiresReview,
            reviewComments: api.reviewComments,
            events: (api.events ?? []).map(e => ({
                id: e.id,
                occurredAt: new Date(e.occurredAt),
                isSuccess: e.isSuccess,
                response: e.response,
                primaryDocument: e.primaryDocument ? {
                    id: e.primaryDocument.id,
                    name: e.primaryDocument.name,
                    fileName: e.primaryDocument.fileName,
                    size: e.primaryDocument.size,
                    extension: e.primaryDocument.extension,
                } : null,
            })),
        };
    }

    static toDomainList(items: OrderCommunicationApi[]): OrderCommunication[] {
        return items.map(OrderCommunicationMapper.toDomain);
    }
}
